<template>



	<el-form v-if="form" label-position="top">
		<el-form-item label="ID">
			<el-input v-model="form.id" :disabled="mode!='create'"></el-input>
		</el-form-item>


		<el-form-item label="名称">
			<el-input v-model="form.name" :disabled="mode!='create'"></el-input>
		</el-form-item>


		<el-form-item>
			<el-button type="primary" @click="submit">save</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
	import ImageUpload from '@/components/ImageUpload'
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {
			ImageUpload,
		},
		data() {
			return {
				form: {},
			}
		},
		mounted() {
			this.form = {
				...this.propForm
			}
		},
		methods: {

			close() {
				this.$emit('close');
			},
			submit() {
				if (this.mode == 'create') {
					request({
						url: '/api/llm/createLlm',
						data: {
							...this.form,
						},
						success: resp => {
							Message.success();
							this.$emit('success')
						}
					})
				} else if (this.mode == 'update') {
					request({
						url: '/api/llm/updateLlm',
						data: {
							...this.form,
						},
						success: resp => {
							Message.success();
							this.$emit('success')
						}
					})
				}
			},


		}
	}
</script>

<style>

</style>